<template>
  <div>
    <el-form :inline="false" label-position="top" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <!-- 创建时间 -->
          <el-form-item :label="$t('collectionCenter.CreationTime')" class="numberSearch">
            <el-date-picker
              v-model="queryForm.params.createTime"
              :default-time="['00:00:00', '23:59:59']"
              :end-placeholder="$t('GlobalSetObj.endDate')"
              :start-placeholder="$t('GlobalSetObj.startDate')"
              range-separator="-"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--限制的问题件-->
          <el-form-item :label="$t('navbar.LimitedProblem')">
            <el-select
              v-model="queryForm.params.problemTypeIdList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              collapse-tags
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in reasonList"
                :key="item.id"
                :label="item.dictDescribe"
                :value="item.problemId"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--网点-->
          <el-form-item :label="$t('customerManagements.site')">
            <ElSelectV2
              v-model="queryForm.params.siteIdList"
              :options="siteList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              collapse-tags
              filterable
              multiple
              size="small"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <!--账号-->
        <el-col :span="4">
          <el-form-item :label="$t('customerManagements.account')" prop="userIdList">
            <el-select
              v-model="queryForm.params.userIdList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="getAllUserList"
              clearable
              collapse-tags
              filterable
              multiple
              remote
              reserve-keyword
              style="width: 100%"
              @visible-change="openUserList"
            >
              <el-option
                v-for="item in accountList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <!--  类型   -->
          <el-form-item :label="$t('GlobalSetObj.Type')">
            <el-select
              v-model="queryForm.params.restrictTypeList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              collapse-tags
              multiple
              style="width: 100%"
            >
              <!--登记问题件距离-->
              <el-option :label="$t('navbar.RegisterProblemDistance')" :value="1" />
              <!--强制提供照片-->
              <el-option :label="$t('navbar.ForcePhoto')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div style="margin-bottom: 15px">
            <!--搜索-->
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm()"
            >{{ $t('newOrder.reset') }}
            </el-button>
            <el-button size="small" type="primary" @click="newRestrictions">{{ $t('GlobalSetObj.add') }}
            </el-button>
            <el-button
              plain size="small" type="primary"
              @click="statusBtn(1)"
            >{{ $t('GlobalSetObj.enable') }}
            </el-button>
            <el-button
              plain size="small" type="danger"
              @click="statusBtn(0)"
            >{{ $t('GlobalSetObj.stop') }}
            </el-button>
            <el-button size="small" @click="exportsTable">{{ $t('operationCenter.exports') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!--  表格数据  -->
    <el-table
      ref="multipleTable"
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        align="center" fixed="left" type="selection"
        width="55"
      />
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="70"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :align="item.cloAlign"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="item.isTips"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'statusName'">
            <el-tag v-if="scope.row.status === 1">{{ scope.row.statusName }}</el-tag>
            <el-tag v-else type="danger">{{ scope.row.statusName }}</el-tag>
          </div>
          <div v-else-if="item.prop === 'mustDistanceName'">
            <el-tag v-if="scope.row.mustPic === 1">{{ $t('GlobalSetObj.yes') }}</el-tag>
            <el-tag v-else type="danger">{{ $t('GlobalSetObj.No') }}</el-tag>
          </div>
          <div v-else>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '- -' }}</div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('newOrder.operation')" align="center" fixed="right"
        width="100"
      >
        <template slot-scope="scope">
          <div style="display: flex; justify-content: space-between; align-items: center">
            <el-tooltip
              :content="$t('GlobalSetObj.edit')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-edit textOperator" @click="editData(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.status === 0"
              :content="$t('GlobalSetObj.enable')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-circle-check textOperator" @click="updateStatus(scope.row)" />
            </el-tooltip>
            <el-tooltip
              v-else
              :content="$t('GlobalSetObj.stop')"
              class="item"
              effect="dark"
              placement="top"
            >
              <i class="el-icon-remove-outline textOperator1" @click="updateStatus(scope.row)" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- 新增限制 -->
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="$t('navbar.RegisterProblemLimitConfiguration')"
      :visible.sync="addDialog"
      top="5vh"
      width="800px"
    >
      <editConfiguration
        :key="configurationKey"
        :edit-data-form="editDataForm"
        :edit-site-object="editSiteObject"
        :other-reason-list="otherReasonList"
        @closeDialog="closeDialog"
      />
    </el-dialog>
  </div>
</template>

<script>
import {
  batchIsOpenedProblemLimit,
  exportProblemLimit,
  getProblemLimitPage,
  getProblemLimitPmUserList
} from '@/api/resources';
import { getAllsite } from '@/api/logisticsOrders';
import { goResourceTaskList } from '@/utils/goExportList';
import { problemQuery } from '@/api/lanshou';
import editConfiguration from './editConfiguration.vue';
import ElSelectV2 from 'el-select-v2';
import dayjs from 'dayjs';

const startTime = dayjs().format('YYYY-MM-DD') + ' 00:00:00';
const endTime = dayjs().format('YYYY-MM-DD') + ' 23:59:59';
export default {
  name: 'RegistrationConfiguration',
  components: { ElSelectV2, editConfiguration },
  data() {
    return {
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          createTime: [startTime, endTime],
          problemTypeIdList: [],
          siteIdList: [],
          restrictTypeList: [],
          userIdList: []
        }
      },
      tableData: [],
      tableHeaderList: [
        // 创建时间
        {
          label: this.$t('GlobalSetObj.CreationTime'),
          prop: 'createTime',
          cloWidth: '160',
          cloAlign: 'center'
        },
        // 状态
        {
          label: this.$t('GlobalSetObj.status'),
          prop: 'statusName',
          cloWidth: '150',
          cloAlign: 'center'
        },
        // 限制的问题件
        {
          label: this.$t('navbar.LimitedProblem'),
          prop: 'problemTypeName',
          cloWidth: '160',
          cloAlign: 'center',
          isTips: true
        },
        // 州
        {
          label: this.$t('collectionCenter.state'),
          prop: 'stateName',
          cloWidth: '160',
          cloAlign: 'center',
          isTips: true
        },
        // 网点
        {
          label: this.$t('GlobalSetObj.Outlets'),
          prop: 'siteName',
          cloWidth: '160',
          cloAlign: 'center',
          isTips: true
        },
        // 账号
        {
          label: this.$t('customerManagements.account'),
          prop: 'userName',
          cloWidth: '160',
          cloAlign: 'center',
          isTips: true
        },
        // 客户
        {
          label: this.$t('GlobalSetObj.client'),
          prop: 'customerName',
          cloWidth: '160',
          cloAlign: 'center',
          isTips: true
        },
        // 商户
        {
          label: this.$t('collectionCenter.CommercialOwner'),
          prop: 'merchantName',
          cloWidth: '190',
          cloAlign: 'center',
          isTips: true
        },
        // 问题件登记距离
        {
          label: this.$t('navbar.ProblemRegistrationDistance') + '(M)',
          prop: 'distance',
          cloWidth: '190',
          cloAlign: 'center'
        },
        // 强制提供照片
        {
          label: this.$t('navbar.ForcePhoto'),
          prop: 'mustDistanceName',
          cloWidth: '160',
          cloAlign: 'center'
        }
      ],
      addDialog: false,
      siteList: [],
      editSiteObject: {
        id: null,
        problemTypeIds: [], // 限制的问题件原因
        stateList: [], // 限制的州
        siteIds: [], // 限制的网点
        userIds: [], // 限制的账号
        customerIds: [], // 客户
        merchantCodes: [], // 商户
        mustDistance: null, // 是否必填距离
        distance: null, // 距离
        mustPic: null // 是否必填图片
      },
      multipleSelection: [],
      accountList: [],
      configurationKey: new Date().getTime(),
      reasonList: [],
      otherReasonList: [], // 操作里的数据接口不一样
      editDataForm: null
    };
  },
  created() {
    this.getSearch();
    this.getAllSite();
    this.getAllUserList();
    this.problemTypePage();
    this.otherProblemPage();
  },
  methods: {
    // 问题件原因list
    problemTypePage() {
      problemQuery().then((res) => {
        if (res.code === 200) {
          this.reasonList = res.data;
        }
      });
    },
    otherProblemPage() {
      problemQuery().then((res) => {
        if (res.code === 200) {
          this.otherReasonList = res.data;
        }
      });
    },
    // 关闭配置弹窗
    closeDialog(val) {
      if (val === 1) {
        this.getSearch();
      }
      this.addDialog = false;
    },
    // 列表数据勾选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出
    exportsTable() {
      const param = {
        beginTime: null,
        endTime: null,
        restrictTypeList: this.queryForm.params.restrictTypeList,
        siteIdList: this.queryForm.params.siteIdList,
        userIdList: this.queryForm.params.userIdList,
        problemTypeIdList: this.queryForm.params.problemTypeIdList
      };
      if (this.queryForm.params.createTime && this.queryForm.params.createTime.length > 0) {
        param.beginTime = this.queryForm.params.createTime[0];
        param.endTime = this.queryForm.params.createTime[1];
      }
      exportProblemLimit(param).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 批量启用、停用
    statusBtn(val) {
      if (this.multipleSelection.length === 0) {
        this.$message.warning(this.$t('collectionCenter.pleaseSelectData'));
      } else {
        const idList = [];
        this.multipleSelection.forEach((item) => {
          idList.push(item.id);
        });
        const data = {
          status: val !== 0,
          idList
        };
        this.$confirm(this.$t('customerManagements.tip103'), this.$t('collectionCenter.tips'), {
          confirmButtonText: this.$t('collectionCenter.confirm'), // '确定'
          cancelButtonText: this.$t('collectionCenter.cancel'), // '取消'
          type: 'warning'
        }).then(async() => {
          batchIsOpenedProblemLimit(data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.ModificationSuccessful'));
              this.$refs.multipleTable.clearSelection();
              this.getSearch();
            }
          });
        });
      }
    },
    // 新增
    newRestrictions() {
      this.editDataForm = null;
      this.editSiteObject = {
        problemTypeIds: [], // 限制的问题件原因
        stateList: [], // 限制的州
        siteIds: [], // 限制的网点
        userIds: [], // 限制的账号
        customerIds: [], // 客户
        merchantCodes: [], // 商户
        mustDistance: null, // 是否必填距离
        distance: null, // 距离
        mustPic: null // 是否必填图片
      };
      this.addDialog = true;
      this.configurationKey = new Date().getTime();
    },
    // 搜索
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.queryForm.params = {
        createTime: [startTime, endTime],
        problemTypeIdList: [],
        siteIdList: [],
        restrictTypeList: [],
        userIdList: []
      };
      this.getSearch();
    },
    // 查询
    getSearch() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {
          beginTime: null,
          endTime: null,
          restrictTypeList: this.queryForm.params.restrictTypeList,
          siteIdList: this.queryForm.params.siteIdList,
          userIdList: this.queryForm.params.userIdList,
          problemTypeIdList: this.queryForm.params.problemTypeIdList
        }
      };
      if (this.queryForm.params.createTime && this.queryForm.params.createTime.length > 0) {
        data.params.beginTime = this.queryForm.params.createTime[0];
        data.params.endTime = this.queryForm.params.createTime[1];
      }
      getProblemLimitPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    // 编辑
    editData(row) {
      this.editDataForm = JSON.parse(JSON.stringify(row));
      this.editSiteObject = {
        id: this.editDataForm.id,
        mustPic: this.editDataForm.mustPic,
        mustDistance: this.editDataForm.mustDistance,
        distance: this.editDataForm.distance,
        userIds: this.editDataForm.userId ? JSON.parse(this.editDataForm.userId) : [-1],
        problemTypeIds: this.editDataForm.problemTypeId
          ? JSON.parse(this.editDataForm.problemTypeId)
          : [-1],
        siteIds: this.editDataForm.siteId ? JSON.parse(this.editDataForm.siteId) : [-1],
        stateList: this.editDataForm.state ? JSON.parse(this.editDataForm.state) : [-1],
        customerIds: this.editDataForm.customerId ? JSON.parse(this.editDataForm.customerId) : [-1],
        merchantCodes: this.editDataForm.merchantCode
          ? JSON.parse(this.editDataForm.merchantCode)
          : [-1]
      };
      this.addDialog = true;
      this.configurationKey = new Date().getTime();
    },
    // 单个启用停用
    updateStatus(row) {
      const data = {
        idList: [row.id],
        status: row.status !== 1
      };
      this.$confirm(this.$t('customerManagements.tip103'), this.$t('collectionCenter.tips'), {
        confirmButtonText: this.$t('collectionCenter.confirm'), // '确定'
        cancelButtonText: this.$t('collectionCenter.cancel'), // '取消'
        type: 'warning'
      })
        .then(async() => {
          batchIsOpenedProblemLimit(data).then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.ModificationSuccessful'));
              this.getSearch();
            }
          });
        })
        .catch(() => {
          console.log('取消关闭');
        });
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    // 获取所有网点
    getAllSite() {
      getAllsite().then((res) => {
        if (res.code === 200) {
          this.siteList = res.data.map((item) => {
            return {
              label: item.name,
              value: item.id
            };
          });
        }
      });
    },
    // 获取全部账号
    getAllUserList(name = '') {
      const param = {
        pageNumber: 1,
        pageSize: 20,
        params: {
          userName: name,
          accountState: 1
        }
      };
      getProblemLimitPmUserList(param).then((response) => {
        if (response.code === 200) {
          this.accountList = response.data.records.map((item) => {
            return {
              label: item.username,
              value: item.id
            };
          });
        }
      });
    },
    // 打开用户选项弹窗
    openUserList(val) {
      if (val) {
        this.getAllUserList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.textOperator {
  color: #00A551;
  cursor: pointer;
  font-size: 22px;
}

.textOperator1 {
  color: #f56c6c;
  cursor: pointer;
  font-size: 22px;
}
</style>
